export const getNavigation = (t: any) => [
  // Analitik
  {
    text: t('analytics'),
    icon: 'chart',
    path: '',
    items: [
      {
        text: t('dashboard'),
        icon: 'home',
        path: '/dashboard',
        items: [],
      },
      {
        text: t('planning'),
        icon: 'event',
        path: '/planning',
        items: [],
      },
      {
        text: t('liveTracking'),
        icon: 'globe',
        path: '/live-tracking',
        items: [],
      },
    ],
  },
  // Rota Yönetimi
  {
    text: t('routeManagement'),
    icon: 'map',
    path: '',
    items: [
      {
        text: t('drivers'),
        icon: 'user',
        path: '/vrp/drivers',
        items: [],
      },
      {
        text: t('vehicles'),
        icon: 'car',
        path: '/vehicles',
        items: [],
      },
      {
        text: 'Müşteriler',
        icon: 'group',
        path: '/customers',
        items: [],
      },
      {
        text: 'Görevler',
        icon: 'todo',
        path: '/tasks',
        items: [],
      },
      {
        text: 'Depolar',
        icon: 'home',
        path: '/warehouses',
        items: [],
      },
      {
        text: t('routes'),
        icon: 'map',
        path: '/routes',
        items: [],
      },
      {
        text: 'Rota Planları',
        icon: 'detailslayout',
        path: '/route-plans',
        items: [],
      },
    ],
  },
  // Bölgeler
  {
    text: t('regions'),
    icon: 'selectall',
    path: '/regions',
    items: [],
  },
  // Administration
  {
    text: t('administration'),
    icon: 'preferences',
    path: '',
    items: [
      {
        text: 'Şirketler',
        icon: 'home',
        path: '/companies',
        items: [],
      },
      {
        text: t('auth'),
        path: '',
        items: [
          {
            text: t('users'),
            path: '/users',
            items: [],
          },
          {
            text: t('roles'),
            path: '/roles',
            items: [],
          }
        ],
      },
      {
        text: t('settings'),
        path: '',
        items: [
          {
            text: t('theme'),
            path: '/theme',
            items: [],
          }
        ],
      }
    ],
  },
  // Destek
  {
    text: t('support'),
    icon: 'help',
    path: '',
    items: [
      {
        text: t('tickets'),
        path: '/tickets',
        items: [],
      }
    ],
  }
];
